import { View } from 'react-native'
import PricePackage from '@order/PricePackage'
import DiscountPackage from '@order/PricePackage/DiscountPackage'
import { PackagePointsTileProps } from '../types'
import { colorOption } from '@order/Package/styles'

type Props = Pick<PackagePointsTileProps, 'tier' | 'price' | 'discount'>

export default function PackageBottom(props: Props) {
  const { tier = 'default', price, discount } = props
  return (
    <View className="absolute bottom-0 left-0 right-0 flex w-full flex-row items-center justify-center gap-8 px-8 pb-8">
      <PricePackage
        hideDiscountPrefix
        price={price}
        colorOption={colorOption[tier]}
      />
      {discount && <DiscountPackage discount={discount} />}
    </View>
  )
}
